import Text from '@components/common/text';
import Modal from '@components/common/modal';
import Button from '@components/common/button';
import { useProfileAuditConfirmAll } from '@repository/profiles/useProfile';
import { useInsightAutoSaved } from '@repository/insight/useInsight';

import useProfileConditions from '@repository/profiles/useProfileConditions';
import useProfileEducation from '@repository/profiles/useProfileEducation';
import useProfileCareer from '@repository/profiles/useProfileCareer';
import useProfileProjects from '@repository/profiles/useProfileProject';
import useProfileExperience from '@repository/profiles/useProfileExperience';
import useProfilePrize from '@repository/profiles/useProfilePrize';
import { FontStyle } from '@domain/constant/fontStyle';
import useModal from '@utils/hooks/useModal';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  visible: boolean;
  confirm: () => void;
  close: () => void;
}
const ConfirmModal = ({ visible, confirm, close }: Props) => {
  return (
    <Modal visible={visible} dimmed>
      <div className={cx('confirmModal')}>
        <Text fontStyle={FontStyle.H4_B}>
          저장된 지원서 내용을 <br /> 모두 확인 하셨나요?
        </Text>
        <div className={cx('btnArea')}>
          <Button theme="secondary" className={cx('btn')} onClick={close}>
            취소
          </Button>
          <Button className={cx('btn')} onClick={confirm}>
            확인
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const NoticeAutoSave = () => {
  const { data: insightAutoSavedData, refetch } = useInsightAutoSaved();

  const { openModal, closeModal, isModalOpen } = useModal();
  const { refetch: refetch1 } = useProfileConditions(false);
  const { refetch: refetch2 } = useProfileEducation(false);
  const { refetch: refetch3 } = useProfileCareer(false);
  const { refetch: refetch4 } = useProfileProjects(false);
  const { refetch: refetch5 } = useProfileExperience(false);
  const { refetch: refetch6 } = useProfilePrize(false);

  const refetchProfile = async () => {
    refetch();
    refetch1();
    refetch2();
    refetch3();
    refetch4();
    refetch5();
    refetch6();
  };

  const { mutateAsync: fetchConfirm } = useProfileAuditConfirmAll(async () => {
    await refetchProfile();
    closeModal();
  });

  const handleConfirm = async () => {
    fetchConfirm();
  };

  if (!insightAutoSavedData?.auditCount) return null;

  return (
    <>
      <div className={cx('wrap')}>
        <Text fontStyle={FontStyle.B1_B}>
          확인이 필요한 정보가 <span className={cx('autoSave')}>{insightAutoSavedData?.auditCount}개</span> 있습니다.
        </Text>

        <Button className={cx('btn')} onClick={openModal}>
          확인 완료
        </Button>
      </div>
      <ConfirmModal visible={isModalOpen} confirm={handleConfirm} close={closeModal} />
    </>
  );
};

export default NoticeAutoSave;
